import { fetchBackend } from './fetch';
import phone from 'phone';

let accessToken;
let whatsappBusinessAccountId;
let phoneNumberId;

//TRAIGO TODOS LOS TEMPLATES ASOCIADOS CON MI WHATSAPP BUSINESS ACCOUNT
const getWhatsappApiTemplates = async(WACredentials) => {
    const { accessToken, whatsappBusinessAccountId, phoneNumberId } = WACredentials;
    
    try {
        const templateResponse = await fetchBackend(
            `meta-api-get-templates?accessToken=${accessToken}&whatsappBusinessAccountId=${whatsappBusinessAccountId}&phoneNumberId=${phoneNumberId}`,
            'GET'
        );
        
        const json = await templateResponse.json();
        
        // Verifica si hay error en la respuesta del backend
        if (!json.ok || json.error) {
            console.error('Backend Error:', json.msg || json.error);
            return { allTemplates: [], approvedTemplates: [] };
        }
        
        const { allTemplates = [], approvedTemplates = [] } = json;
        
        console.log('Templates from backend - All:', allTemplates);
        console.log('Templates from backend - Approved:', approvedTemplates);
        
        return { allTemplates, approvedTemplates };
        
    } catch (err) {
        console.error('Error fetching templates:', err);
        return { allTemplates: [], approvedTemplates: [] };
    }
}

//CREAR UN NUEVO TEMPLATE ASOCIADO A WHATSAPP BUSINESS ACCOUNT - FUNCIONA CORRECTAMENTE ** PENDIENTE LLEVAR AL BACK
const postWhatsappApiTemplates = async(WACredentials, templateParams) => {
    accessToken =  WACredentials.accessToken
    whatsappBusinessAccountId =  WACredentials.whatsappBusinessAccountId
    phoneNumberId =  WACredentials.phoneNumberId

    const url = `https://graph.facebook.com/v22.0/${whatsappBusinessAccountId}/message_templates`;
    console.log('postWhatsappApiTemplates funcion URL:', url)
    const options = {
        method: 'POST',
        headers: {
            Accept: '*/*',
            'Content-Type': 'application/json',
            Authorization: `Bearer ${accessToken}`
        },
        body: JSON.stringify(templateParams)
    };
    
    return fetch(url, options)
                .then(res => res.json())
                .catch(err => console.error('error:' + err));
}

// ELIMINAR UN TEMPLATE ASOCIADO A WHATSAPP BUSINESS ACCOUNT - FUNCIONA CORRECTAMENTE ** PENDIENTE LLEVAR AL BACK
const deleteWhatsappApiTemplate = async(WACredentials, templateName) => {
    accessToken =  WACredentials.accessToken
    whatsappBusinessAccountId =  WACredentials.whatsappBusinessAccountId
    phoneNumberId =  WACredentials.phoneNumberId

    const url = `https://graph.facebook.com/v22.0/${whatsappBusinessAccountId}/message_templates?name=${templateName}&access_token=${accessToken}`
    console.log('deleteWhatsappApiTemplate funcion URL:', url)
    const options = {
        method: 'DELETE',
        headers: {
            Accept: '*/*',
            'Content-Type': 'application/json',
        }
    };

    return fetch(url, options)
                .then(res => res.json())
                .catch(err => console.log(err));
}

//ENVIO DE MENSAJE FUNCIONANDO SIN VARIABLES ** FALTA CONDICIONAL PARA AGREGAR VARIABLES 
const sendTemplateMessage = async(WACredentials, template, phone, contactInfo = {}, numberOrigin) => {
    const { accessToken, whatsappBusinessAccountId, phoneNumberId } = WACredentials;
    
    // Construir la URL con query parameters
    const queryParams = new URLSearchParams({
        accessToken,
        whatsappBusinessAccountId,
        phoneNumberId
    });
    
    // El endpoint con los query parameters
    const endpoint = `send-meta-harbinger-single?${queryParams.toString()}`;
     // AGREGAR bodyText para poder guardarlo en BD
    const bodyText = template.components?.find(c => c.type === 'BODY')?.text || '';

     // 🔍 VERIFICAR SI HAY COMPONENTES CON PARAMETERS (variables reales)
    const hasParameters = template.components && 
        Array.isArray(template.components) && 
        template.components.length > 0 &&
        template.components.some(comp => 
            comp.parameters && 
            Array.isArray(comp.parameters) && 
            comp.parameters.length > 0
        );
    
    // 📦 EL BODY AHORA INCLUYE LOS COMPONENTES SI EXISTEN
    const data = {
        to: phone,
        template: {
            name: template.name,
            language: template.language || template.language?.code || 'es',
            bodyText: bodyText, // 🆕 Para guardar en BD
            ...(hasParameters && {
                components: template.components
            })
        },
        contactInfo: contactInfo, // 🆕 Información del contacto
        email: contactInfo.email || null, // 🆕 Email del usuario
        numberOrigin: numberOrigin // 🆕 Número de origen del mensaje
    };


    console.log('Enviando template:', template);
    console.log('Al teléfono:', phone);
    console.log('Con datos:', data);
    
    try {
        const response = await fetchBackend(endpoint, data, 'POST');
        const result = await response.json();
        return result;
    } catch (error) {
        console.error('Error en sendTemplateMessage:', error);
        return { ok: false, msg: error.message };
    }
};

// OBTENER INFORMACION DEL NUMERO DE TELEFONO ASOCIADO A WHATSAPP BUSINESS ACCOUNT AL INICIALIZAR LA APLICACION **PENDIENTE LLEVAR AL BACK
const getPhoneNumberInformation = async(WACredentials) => {
    accessToken = WACredentials.accessToken
    phoneNumberId = WACredentials.phoneNumberId

    const url = `https://graph.facebook.com/v22.0/${phoneNumberId}`;
    // console.log('getPhoneNumberInformation funcion URL:', url)
    const options = {
        method: 'GET',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: `Bearer ${accessToken}`
        }
    };
    
    const dataResponse = await fetch(url, options)
                                .then(res => res.json())
                                .catch(err => console.error('error:' + err));

    if(dataResponse.error){
        return dataResponse
    } else {
        const number = await dataResponse.display_phone_number
        const iso2 = phone(`+${number}`).isValid ? phone(`+${number}`).countryIso2 : 'US'
        const flagUrl = `https://flagcdn.com/${iso2.toLowerCase()}.svg`;
        const WAPhoneInformation = {
            code_verification_status: await dataResponse.code_verification_status,
            display_phone_number: await dataResponse.display_phone_number,
            id: await dataResponse.id,
            quality_rating: await dataResponse.quality_rating,
            verified_name: await dataResponse.verified_name,
            country_flag: flagUrl
        }
        return WAPhoneInformation
    }
}


// ELIMINAR UN TEMPLATE ASOCIADO A WHATSAPP BUSINESS ACCOUNT - ** REVISAR ERROR AL ACTUALIZAR Y ELIMINAR ** PENDIENTE LLEVAR AL BACK
const handleDeleteCredentials = async(configuration, card, email) => {
    const cardId = await card.id
    const activeCredentials = await configuration.whatsappAPIcredentials
    const filteredCredentials = await activeCredentials.filter( cred => cred.phoneNumberId !== cardId)

    const newSelectedWACredentials = await configuration.selectedWACredentials === cardId ? '' : await configuration.selectedWACredentials

    const settings = {
        delay: await configuration.delay,
        language: await configuration.language,
        oscilacionTiempo: await configuration.oscilacionTiempo,
        selectedWACredentials: await newSelectedWACredentials,
        whatsappAPIcredentials: await filteredCredentials
    }

    const data = { email, settings: JSON.stringify(settings) }
    
    const saveConfigurationRequest = await fetchBackend( 'settings', {data}, 'PUT' )
    const saveConfigurationResponse = await saveConfigurationRequest.json();
    const saveSuccess = await saveConfigurationResponse.ok

    return saveSuccess
}

const handleUpdateSelectedCredentials = async(configuration, cardId, email) => {
    const settings = {
        delay: await configuration.delay,
        language: await configuration.language,
        oscilacionTiempo: await configuration.oscilacionTiempo,
        selectedWACredentials: await cardId,
        whatsappAPIcredentials: await configuration.whatsappAPIcredentials
    }

    const data = { email, settings: JSON.stringify(settings) }
    
    const saveConfigurationRequest = await fetchBackend( 'settings', {data}, 'PUT' )
    const saveConfigurationResponse = await saveConfigurationRequest.json();
    const saveSuccess = await saveConfigurationResponse.ok

    return saveSuccess
}

// ELEMENTOS PARA REEMPLAZAR VARIABLES
const insertVariablesSelectElements = async(newVar) => {
    const selectElement = document.createElement('select')
    selectElement.id = `exampleVar${newVar}`
    selectElement.className = 'form-select form-select-sm mb-2'
    selectElement.required = true
    selectElement.defaultValue = 'default'

    const optionElement0 = document.createElement('option')
    const optionElement1 = document.createElement('option')
    const optionElement2 = document.createElement('option')
    const optionElement3 = document.createElement('option')
    const optionElement4 = document.createElement('option')
    const optionElement5 = document.createElement('option')
    const optionElement6 = document.createElement('option')
    const optionElement7 = document.createElement('option')
    const optionElement8 = document.createElement('option')
    const optionElement9 = document.createElement('option')
    const optionElement10 = document.createElement('option')
    const optionElement11 = document.createElement('option')

    optionElement0.innerText = `Campo para la variable ${newVar}`
    optionElement0.value = 'default'
    optionElement0.hidden = true
    optionElement1.innerText = 'Nombre'
    optionElement1.value = '$NOMBRE$'
    optionElement2.innerText = 'Apellido'
    optionElement2.value = '$APELLIDO$'
    optionElement3.innerText = 'Pais'
    optionElement3.value = '$PAIS$'
    optionElement4.innerText = 'Teléfono'
    optionElement4.value = '$NUMERO$'
    optionElement5.innerText = 'Cargo'
    optionElement5.value = '$CARGO$'
    optionElement6.innerText = 'Observaciones'
    optionElement6.value = '$OBSERVACIONES$'
    optionElement7.innerText = 'Empresa'
    optionElement7.value = '$EMPRESA$'
    optionElement8.innerText = 'Monto'
    optionElement8.value = '$MONTO$'
    optionElement9.innerText = 'Fecha Vencimiento'
    optionElement9.value = '$FECHAVENCIMIENTO$'
    optionElement10.innerText = 'Numero Factura'
    optionElement10.value = '$NUMEROFACUTRA$'
    optionElement11.innerText = 'Fecha Cumpleaños'
    optionElement11.value = '$FECHACUMPLEAÑOS$'

    selectElement.appendChild(optionElement0)
    selectElement.appendChild(optionElement1)
    selectElement.appendChild(optionElement2)
    selectElement.appendChild(optionElement3)
    selectElement.appendChild(optionElement4)
    selectElement.appendChild(optionElement5)
    selectElement.appendChild(optionElement6)
    selectElement.appendChild(optionElement7)
    selectElement.appendChild(optionElement8)
    selectElement.appendChild(optionElement9)
    selectElement.appendChild(optionElement10)
    selectElement.appendChild(optionElement11)

    document.querySelector('#insertedVarInputs').appendChild(selectElement)
}

export {
    getWhatsappApiTemplates,
    postWhatsappApiTemplates,
    deleteWhatsappApiTemplate,
    sendTemplateMessage,
    getPhoneNumberInformation,
    handleDeleteCredentials,
    handleUpdateSelectedCredentials,
    insertVariablesSelectElements
}
